import type { ReactNode } from 'react'
import { AlertCircle, AlertTriangle, ShieldCheck } from 'lucide-react'
import Button from '@/components/button'
import DefaultModal from '@/components/default-modal'
import styles from './style.module.css'

type Tone = 'danger' | 'success' | 'warning'

interface ConfirmDialogProps {
  isOpen: boolean
  toggle: () => void
  title: string
  message: ReactNode
  confirmLabel?: string
  cancelLabel?: string
  isDestructive?: boolean
  tone?: Tone
  isLoading?: boolean
  onConfirm: () => void
  children?: ReactNode
}

const ICONES: Record<Tone, ReactNode> = {
  danger: <AlertTriangle size={40} />,
  success: <ShieldCheck size={40} />,
  warning: <AlertCircle size={40} />,
}

const VARIANTES = { danger: 'danger', success: 'success', warning: 'primary' } as const

const ConfirmDialog = ({
  cancelLabel = 'Cancelar',
  children,
  confirmLabel = 'Confirmar',
  isDestructive = false,
  isLoading = false,
  isOpen,
  message,
  onConfirm,
  title,
  toggle,
  tone,
}: ConfirmDialogProps) => {
  const tomEfetivo: Tone = tone ?? (isDestructive ? 'danger' : 'warning')

  return (
    <DefaultModal
      isOpen={isOpen}
      toggle={toggle}
      title={title}
      size="sm"
      closeOnOverlay={!isLoading}
      footer={
        <>
          <Button variant="secondary" onClick={toggle} disabled={isLoading}>
            {cancelLabel}
          </Button>
          <Button variant={VARIANTES[tomEfetivo]} onClick={onConfirm} isLoading={isLoading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <div className={styles.content}>
        <span className={styles[tomEfetivo]}>{ICONES[tomEfetivo]}</span>
        <p className={styles.message}>{message}</p>
        {children}
      </div>
    </DefaultModal>
  )
}

export default ConfirmDialog
